import { CompletionFormatEnum } from '../../../api/ai/enums/completion-format.enum';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';

export class AiFormatConfigModel {
    showFormat: boolean;
    defaultFormat: CompletionFormatEnum;
    formatOptions: DropdownOptionModel[];
}
